/*
 * Talika — Consultation Beauté (P1)
 * Expérience conversationnelle avec Talia, experte beauté virtuelle.
 * Dépend de window.TalikaEngine (diagnostic-engine.js) et de window.TalikaConfig.
 * Divulgation IA : voir section liquid (accueil + footer permanent) — obligatoire.
 */
(function () {
  'use strict';

  const E = window.TalikaEngine;
  if (!E) { console.error('TalikaEngine manquant'); return; }

  // Avatar Talia (variante C « L'œil » — choix Robin 17/08) — emblème, jamais de photo réelle
  const TALIA_SVG = '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="tbg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f7fbfc"/><stop offset="1" stop-color="#dceef2"/></linearGradient></defs><circle cx="100" cy="100" r="100" fill="url(#tbg)"/><circle cx="100" cy="100" r="86" fill="none" stroke="#66a8bc" stroke-width="1.5" opacity=".5"/><path d="M48 104 C 70 76, 130 76, 152 104 C 130 128, 70 128, 48 104 Z" fill="#fff" stroke="#1f2937" stroke-width="5"/><circle cx="100" cy="103" r="17" fill="#4a90a4"/><circle cx="100" cy="103" r="8" fill="#1f2937"/><circle cx="105" cy="98" r="3.5" fill="#fff"/><path d="M62 88 L56 79 M76 80 L72 70 M92 76 L90 65 M108 76 L110 65 M124 80 L128 70 M138 88 L144 79" stroke="#1f2937" stroke-width="5" stroke-linecap="round"/><path d="M156 128 l3.5 8 8 3.5 -8 3.5 -3.5 8 -3.5 -8 -8 -3.5 8 -3.5 z" fill="#f59e0b"/></svg>';
  const TALIA = 'data:image/svg+xml;base64,' + (typeof btoa === 'function' ? btoa(unescape(encodeURIComponent(TALIA_SVG))) : '');

  // --- Analyse photo (P2) — Edge Function Supabase, zéro rétention ---
  const VISION_URL = 'https://uvohlnmwiucedehemxrt.supabase.co/functions/v1/consultation-vision';
  const VISION_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV2b2hsbm13aXVjZWRlaGVteHJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NDY4NjYsImV4cCI6MjA4OTQyMjg2Nn0.sPzYDnatw82CqSZDQ-sAvICnPAJUVqnyZMvr9ulXd3g';

  // --- Dialogues de Talia (validés sur fiches produits, jamais de claim inventé) ---
  const S = {
    welcome: 'Bonjour, je suis <b>Talia</b>, votre experte beauté virtuelle 🤍 Un moment rien que pour vous : quelques questions, comme en institut, et je compose votre routine sur mesure.',
    welcomeAsk: 'Dites-moi : quelle est votre priorité aujourd\'hui ?',
    universeReply: { skin: 'Ma peau ✨', lashes: 'Mon regard 👁️' },
    branchIntro: {
      skin: 'Très bien, parlons de votre peau. Pour bien la comprendre, j\'ai trois petites questions.',
      lashes: 'Ravie de m\'occuper de votre regard 👁️ Dites-moi tout.',
    },
    lead: {
      age: 'D\'abord, dans quelle tranche d\'âge vous situez-vous ?',
      skinType: 'Comment sentez-vous votre peau au quotidien ?',
      concerns: 'Et qu\'aimeriez-vous améliorer en priorité ? (plusieurs réponses possibles)',
      lashWishes: 'Qu\'aimeriez-vous pour vos cils ? (plusieurs réponses possibles)',
      lashMascara: 'Utilisez-vous du mascara tous les jours ?',
      mascaraType: 'Alors côté mascara, vous cherchez plutôt…',
      lashEyeliner: 'Et un eyeliner ou un crayon, régulièrement ?',
    },
    ack: {
      age: 'C\'est noté.',
      skinType: 'Merci, je vois très bien.',
      concerns: 'Merci pour votre confiance — je sais exactement quoi vous proposer.',
      lashWishes: 'Très bon choix, c\'est exactement notre spécialité depuis 1948.',
      lashMascara: null, mascaraType: null, lashEyeliner: null,
    },
    mascaraCard: 'Celui-ci maquille <i>et</i> prend soin de vos cils en même temps — je l\'ajoute à votre sélection :',
    photoOffer: 'Pour vous conseiller au plus juste, deux options : <b>montrez-moi votre regard en photo</b> — je la regarde puis elle est immédiatement supprimée — ou répondez à mes questions. Comme vous préférez !',
    photoLooking: 'Je regarde ça…',
    photoCloser: 'Merci ! J\'aimerais voir votre regard d\'un peu plus près pour être sûre de moi 📸 Vous pouvez reprendre la photo, ou répondre à mes questions.',
    photoUnusable: 'Je n\'arrive pas à bien distinguer votre regard sur cette photo — passons par mes questions, c\'est tout aussi bien !',
    photoFail: 'Un petit souci technique de mon côté — continuons avec mes questions !',
    photoConfirm: 'Dites-moi si je vois juste : vous aimeriez',
    recoIntro: 'Votre routine est prête ✨ Je vous explique chacun de mes choix :',
    sections: { morning: '🌅 Le matin', evening: '🌙 Le soir', weekly: '📅 1 à 2 fois par semaine', targeted: '🎯 En soin ciblé' },
    capture: 'Je vous ai réservé <b>−20 € sur votre routine</b> dès 100 € — laissez-moi votre email, votre code vous y attend 🎁',
    crossSell: {
      lashes: { title: 'Et votre regard ?', text: 'Des cils plus longs, plus fournis ? Trois questions et je complète votre routine.', cta: 'Continuer avec mon regard →' },
      skin: { title: 'Et votre peau ?', text: 'Une routine visage sur mesure en trois questions, ajoutée à votre sélection.', cta: 'Continuer avec ma peau →' },
    },
    reasons: {
      // pourquoi ce produit, en fonction de la réponse — formulations issues des fiches
      lipocilsPlatinium: 'Vous voulez une frange plus fournie : le duo jour/nuit Platinium est mon indispensable pour des cils plus nombreux.',
      lipocilsExpert: 'Pour la courbure et la pigmentation, Lipocils Expert est notre sérum culte.',
      lipocils: 'Pour des cils plus longs et résistants, le soin originel Lipocils, formulé depuis 1948.',
      lipocilsDemaquillant: 'Vous vous maquillez tous les jours : ce baume démaquille en stimulant la pousse.',
      lipocilsCrayon: 'Votre trait d\'eyeliner devient un soin : ce crayon fortifie les cils en maquillant.',
      eauMicellaire: 'Pour nettoyer en douceur au quotidien.',
    },
  };

  // --- État ---
  const STORAGE_KEY = 'talika-consultation';
  const state = {
    answers: {}, doneUniverses: [], savedRoutine: null,
    transcript: [], selection: [], routine: null,
    phase: 'welcome', // welcome | questions | done
    pendingMulti: [],
    actions: [], // journal pour la reprise de session
    completionTracked: false, startTracked: false,
    photoThumb: null, photoAxes: null, photoRetryUsed: false, inputMethod: 'questions',
  };
  let instant = false; // replay/tests : pas de délais de frappe

  // --- Rendu ---
  const el = id => document.getElementById(id);
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');

  function bubbleExpert(html) { return '<div class="cb-msg"><img class="cb-avatar" src="' + TALIA + '" alt="Talia, assistante virtuelle"><div class="cb-bubble">' + html + '</div></div>'; }
  function bubbleUser(html) { return '<div class="cb-msg cb-right"><div class="cb-bubble cb-user">' + html + '</div></div>'; }
  function bubbleTyping() { return '<div class="cb-msg"><img class="cb-avatar" src="' + TALIA + '" alt=""><div class="cb-typing"><i></i><i></i><i></i></div></div>'; }

  function productCard(key, withAdd) {
    const p = E.getProduct(key);
    if (!p) return '';
    return '<div class="cb-pcard">' +
      (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
      '<div class="cb-pcard-body"><div class="cb-pcard-t">' + esc(p.name) + '</div>' +
      '<div class="cb-pcard-d">' + esc(p.description) + '</div>' +
      '<div class="cb-pcard-row"><span class="cb-price">' + esc(p.priceFormatted) + '</span>' +
      (withAdd ? '<span class="cb-added">✓ Dans votre sélection</span>' : '') +
      '</div></div></div>';
  }

  function chipsFor(q) {
    const multi = q.type === 'checkbox';
    const html = q.options.map(o => {
      const sel = multi && state.pendingMulti.includes(o.value);
      return '<button class="cb-chip' + (sel ? ' cb-sel' : '') + '" onclick="TalikaConsultation.' + (multi ? 'toggle' : 'answer') + '(\'' + q.id + '\',\'' + o.value + '\')">' + (o.icon ? '<span class="cb-chip-ic">' + o.icon + '</span>' : '') + esc(o.label) + '</button>';
    }).join('');
    const validate = multi ? '<button class="cb-chip cb-validate" onclick="TalikaConsultation.confirmMulti(\'' + q.id + '\')"' + (state.pendingMulti.length ? '' : ' disabled') + '>C\'est tout ✓</button>' : '';
    return '<div class="cb-chips">' + html + validate + '</div>';
  }

  // Pictos univers — dessin au trait, même langage que l'emblème Talia
  const PICTO_SKIN = '<svg class="cb-picto" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="pgs" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f7fbfc"/><stop offset="1" stop-color="#dceef2"/></linearGradient></defs><circle cx="100" cy="100" r="96" fill="url(#pgs)"/><path d="M100 52 C 100 52, 64 98, 64 126 a36 36 0 0 0 72 0 C 136 98, 100 52, 100 52 Z" fill="#fff" stroke="#1f2937" stroke-width="4.5" stroke-linejoin="round"/><path d="M82 128 a19 19 0 0 0 12 17" stroke="#66a8bc" stroke-width="4.5" fill="none" stroke-linecap="round"/><path d="M146 58 l3 7 7 3 -7 3 -3 7 -3 -7 -7 -3 7 -3 z" fill="#f59e0b"/></svg>';
  const PICTO_EYE = '<svg class="cb-picto" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="pge" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f7fbfc"/><stop offset="1" stop-color="#dceef2"/></linearGradient></defs><circle cx="100" cy="100" r="96" fill="url(#pge)"/><path d="M54 96 C 78 124, 122 124, 146 96" fill="none" stroke="#1f2937" stroke-width="4.5" stroke-linecap="round"/><path d="M66 110 L58 122 M84 118 L80 132 M100 121 L100 135 M116 118 L120 132 M134 110 L142 122" stroke="#1f2937" stroke-width="4.5" stroke-linecap="round"/><path d="M146 58 l3 7 7 3 -7 3 -3 7 -3 -7 -7 -3 7 -3 z" fill="#f59e0b"/></svg>';

  function welcomeCards() {
    return '<div class="cb-universe">' +
      '<button class="cb-ucard" onclick="TalikaConsultation.answer(\'universe\',\'skin\')">' + PICTO_SKIN + '<span class="cb-ucard-t">Ma peau</span><span class="cb-ucard-d">Une routine visage personnalisée</span></button>' +
      '<button class="cb-ucard" onclick="TalikaConsultation.answer(\'universe\',\'lashes\')">' + PICTO_EYE + '<span class="cb-ucard-t">Mon regard</span><span class="cb-ucard-d">Des cils plus beaux</span></button>' +
      '</div>';
  }

  function renderEntry(entry) {
    switch (entry.t) {
      case 'expert': return bubbleExpert(entry.html);
      case 'user': return bubbleUser(entry.html);
      case 'typing': return bubbleTyping();
      case 'chips': { const q = findQuestion(entry.qid); return q ? chipsFor(q) : ''; }
      case 'welcome-cards': return welcomeCards();
      case 'pcard': return '<div class="cb-inflow">' + productCard(entry.key, entry.added) + '</div>';
      case 'capture': return '<div class="cb-inflow"><div class="cb-capture" id="cb-capture"><h3>🎁 Recevez votre code −20 € par email</h3><div class="klaviyo-form-Re9bCe"></div><p class="cb-small">🔒 Vos données restent chez Talika · 💬 envoi WhatsApp possible en option</p></div></div>';
      case 'photo-offer': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="TalikaConsultation.choosePhoto()">📸 Choisir une photo</button>' +
        '<button class="cb-chip" onclick="TalikaConsultation.declinePhoto()">💬 Je préfère répondre</button>' +
        '</div><p class="cb-consent">En envoyant votre photo, vous acceptez son analyse automatisée par notre IA pour personnaliser nos recommandations. Elle est supprimée immédiatement après.</p>';
      case 'photo-retry': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="TalikaConsultation.choosePhoto()">📸 Reprendre une photo</button>' +
        '<button class="cb-chip" onclick="TalikaConsultation.declinePhoto()">💬 Répondre aux questions</button></div>';
      case 'photo-confirm': {
        const labels = entry.axes.map(a => E.TARGET_LABELS[a] || a).join(' + ');
        return bubbleExpert(S.photoConfirm + ' <b>' + esc(labels) + '</b> ?') +
          '<div class="cb-chips">' +
          '<button class="cb-chip cb-validate" onclick="TalikaConsultation.confirmPhoto(true)">Oui, exactement ✓</button>' +
          '<button class="cb-chip" onclick="TalikaConsultation.confirmPhoto(false)">Pas tout à fait, je précise</button></div>';
      }
      case 'crosssell': {
        const cs = S.crossSell[entry.next];
        return '<div class="cb-inflow"><div class="cb-cross"><div><h3>' + (entry.next === 'lashes' ? '👁️' : '✨') + ' ' + cs.title + '</h3><p>' + cs.text + '</p></div><button onclick="TalikaConsultation.startCrossSell(\'' + entry.next + '\')">' + cs.cta + '</button></div></div>';
      }
    }
    return '';
  }

  function findQuestion(qid) {
    if (qid === 'universe') return E.QUESTIONS.universe;
    const u = state.answers.universe;
    const list = u ? E.QUESTIONS[u] : [];
    return (list || []).find(q => q.id === qid) || null;
  }

  function renderThread() {
    const thread = el('cb-thread');
    if (!thread) return;
    thread.innerHTML = state.transcript.map(renderEntry).join('');
    const scroller = el('cb-scroll') || thread;
    try { scroller.scrollTop = scroller.scrollHeight; } catch (e) {}
  }

  function profileFields() {
    const a = state.answers;
    const uLabel = { skin: 'Ma peau ✨', lashes: 'Mon regard 👁️' };
    const skinLabel = { dry: 'Sèche 🍂', oily: 'Grasse 🥑', combination: 'Mixte 🌗', normal: 'Normale ⚖️' };
    const ageLabel = { 'under25': 'Moins de 25 ans', '25-35': '25-35 ans', '35-45': '35-45 ans', 'over45': 'Plus de 45 ans' };
    const universes = [].concat(state.doneUniverses, a.universe ? [a.universe] : []);
    const tagFor = v => '<span class="cb-tag">' + esc(E.TARGET_LABELS[v] || v) + '</span>';
    const rows = [];
    rows.push(['Priorité', universes.length ? universes.map(u => uLabel[u]).join(' + ') : null]);
    if (universes.includes('skin') || !universes.length) {
      rows.push(['Type de peau', a.skinType ? skinLabel[a.skinType] : null]);
      rows.push(['Âge', a.age ? ageLabel[a.age] : null]);
    }
    const tags = [].concat(a.concerns || [], a.lashWishes || []);
    let total = 1, done = universes.length ? 1 : 0;
    const qs = a.universe ? E.QUESTIONS[a.universe].filter(q => !q.condition || q.condition(a)) : [];
    total += qs.length;
    done += qs.filter(q => a[q.id] !== undefined && (q.type !== 'checkbox' || (a[q.id] || []).length)).length;
    const pct = Math.min(100, Math.round((done / Math.max(total, 1)) * 100));
    return { rows, tags: tags.map(tagFor).join(''), pct };
  }

  function renderProfile() {
    const panel = el('cb-profile-body');
    if (!panel) return;
    const p = profileFields();
    panel.innerHTML =
      '<div class="cb-gauge"><div style="width:' + p.pct + '%"></div></div>' +
      '<div class="cb-gauge-label">Profil complété à ' + p.pct + ' %</div>' +
      p.rows.map(r => '<div class="cb-field"><span>' + r[0] + '</span>' + (r[1] ? '<b>' + r[1] + '</b>' : '<span class="cb-empty">à découvrir…</span>') + '</div>').join('') +
      (p.tags ? '<div class="cb-field-title">Mes envies</div><div>' + p.tags + '</div>' : '') +
      (state.photoThumb
        ? '<div class="cb-field-title">Ma photo</div><img class="cb-photo-thumb" src="' + state.photoThumb + '" alt="Votre photo (non conservée)">'
        : (state.answers.universe === 'lashes' && !state.photoAxes
          ? '<button class="cb-photo-add" onclick="TalikaConsultation.choosePhoto()">📸 Montrer mon regard (facultatif)</button>' : ''));
  }

  function renderSelection() {
    const panel = el('cb-selection-body');
    if (!panel) return;
    const keys = state.selection;
    const badge = el('cb-tab-badge');
    if (badge) { badge.textContent = keys.length; badge.style.display = keys.length ? 'flex' : 'none'; }
    if (!keys.length) {
      panel.innerHTML = '<p class="cb-empty" style="padding:8px 0;">Votre sélection se remplit au fil de notre conversation ✨</p>';
      return;
    }
    const routine = state.routine || { morning: [], evening: [], weekly: [], targeted: [] };
    const rows = keys.map(key => {
      const p = E.getProduct(key);
      if (!p) return '';
      const usage = E.routineUsage(routine, key);
      const tag = E.concernTag(state.answers, key);
      return '<label class="cb-item"><input type="checkbox" checked onchange="TalikaConsultation.toggleSelection(\'' + key + '\')">' +
        (p.image ? '<img src="' + p.image + '" alt="">' : '') +
        '<span class="cb-item-body"><span class="cb-item-n">' + esc(p.name) + (tag ? ' <span class="cb-tag">🎯 ' + esc(tag) + '</span>' : '') + '</span>' +
        (usage ? '<span class="cb-item-u">' + usage + '</span>' : '') + '</span>' +
        '<span class="cb-item-p">' + esc(p.priceFormatted) + '</span></label>';
    }).join('');
    const total = E.routineValueCents(keys);
    const { amountCents, thresholdCents } = E.ROUTINE_OFFER;
    const offer = total >= thresholdCents
      ? '<div class="cb-total"><span class="cb-strike">' + E.formatEuros(total) + '</span> <b>' + E.formatEuros(total - amountCents) + '</b> <span class="cb-tag cb-tag-green">🎁 −20 € débloqués</span></div>'
      : '<div class="cb-total"><b>' + E.formatEuros(total) + '</b></div>' +
        '<div class="cb-gauge"><div style="width:' + Math.min(100, Math.round(total / thresholdCents * 100)) + '%"></div></div>' +
        '<div class="cb-gauge-label">Plus que <b>' + E.formatEuros(thresholdCents - total) + '</b> pour débloquer <b>−20 €</b></div>';
    panel.innerHTML = rows + offer +
      '<button class="cb-cta" onclick="TalikaConsultation.addSelectionToCart()">🛒 Ajouter ma routine (' + keys.length + ' produit' + (keys.length > 1 ? 's' : '') + ')</button>';
  }

  function renderAll() { renderThread(); renderProfile(); renderSelection(); }

  // --- File de messages avec effet de frappe ---
  let queue = Promise.resolve();
  function say(html) {
    queue = queue.then(() => new Promise(resolve => {
      if (instant) { state.transcript.push({ t: 'expert', html }); renderAll(); resolve(); return; }
      state.transcript.push({ t: 'typing' });
      renderThread();
      setTimeout(() => {
        state.transcript.pop();
        state.transcript.push({ t: 'expert', html });
        renderAll();
        resolve();
      }, Math.min(500 + html.length * 6, 1400));
    }));
    return queue;
  }
  function push(entry) { queue = queue.then(() => { state.transcript.push(entry); renderAll(); }); return queue; }

  // --- Persistance (journal d'actions rejoué en mode instantané) ---
  function saveSession() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ actions: state.actions, ts: Date.now() })); } catch (e) {}
  }
  function logAction(a) { state.actions.push(a); saveSession(); }

  // --- Déroulé ---
  function start() {
    say(S.welcome);
    say(S.welcomeAsk);
    push({ t: 'welcome-cards' });
    state.phase = 'welcome';
  }

  function nextQuestion() {
    const u = state.answers.universe;
    const qs = (E.QUESTIONS[u] || []).filter(q => !q.condition || q.condition(state.answers));
    const next = qs.find(q => state.answers[q.id] === undefined);
    if (!next) { finishBranch(); return; }
    state.pendingMulti = state.prefillMulti || [];
    state.prefillMulti = null;
    say(S.lead[next.id] || '…');
    push({ t: 'chips', qid: next.id });
  }

  function removeInputs() {
    queue = queue.then(() => {
      state.transcript = state.transcript.filter(e => ['chips','welcome-cards','crosssell','photo-offer','photo-retry','photo-confirm'].indexOf(e.t) === -1);
    });
  }

  function answer(qid, value, fromReplay) {
    const q = findQuestion(qid);
    if (!q || q.type === 'checkbox') return;
    if (!fromReplay) logAction({ a: 'answer', qid, value });
    if (!state.startTracked) { state.startTracked = true; E.track('Started Diagnostic', { first_question: qid, source: 'talika-consultation' }); }
    removeInputs();
    const opt = q.options.find(o => o.value === value);
    if (qid === 'universe') {
      state.answers = { universe: value };
      state.completionTracked = false;
      push({ t: 'user', html: S.universeReply[value] });
      say(S.branchIntro[value]);
      state.phase = 'questions';
      // P2 : la photo n'est proposée que pour le regard, jamais avant l'intention
      if (value === 'lashes' && !state.photoAxes && !fromReplay) {
        E.track('Consultation Photo Offered', {});
        say(S.photoOffer);
        push({ t: 'photo-offer' });
        return;
      }
      nextQuestion();
      return;
    }
    state.answers[qid] = value;
    if (qid === 'lashMascara' && value === 'no') delete state.answers.mascaraType;
    push({ t: 'user', html: esc(opt ? opt.label : value) });
    if (S.ack[qid]) say(S.ack[qid]);
    if (qid === 'mascaraType' && opt && opt.productKey) {
      say(S.mascaraCard);
      push({ t: 'pcard', key: opt.productKey, added: true });
    }
    nextQuestion();
  }

  function toggle(qid, value, fromReplay) {
    if (!fromReplay) logAction({ a: 'toggle', qid, value });
    if (!state.startTracked) { state.startTracked = true; E.track('Started Diagnostic', { first_question: qid, source: 'talika-consultation' }); }
    const i = state.pendingMulti.indexOf(value);
    if (i >= 0) state.pendingMulti.splice(i, 1); else state.pendingMulti.push(value);
    renderThread();
  }

  function confirmMulti(qid, fromReplay) {
    if (!state.pendingMulti.length) return;
    if (!fromReplay) logAction({ a: 'confirm', qid });
    const q = findQuestion(qid);
    state.answers[qid] = state.pendingMulti.slice();
    removeInputs();
    const labels = state.answers[qid].map(v => { const o = q.options.find(x => x.value === v); return o ? o.label : v; });
    push({ t: 'user', html: esc(labels.join(' · ')) });
    if (S.ack[qid]) say(S.ack[qid]);
    state.pendingMulti = [];
    nextQuestion();
  }

  function reasonFor(key) {
    if (S.reasons[key]) return S.reasons[key];
    const p = E.getProduct(key);
    const tag = E.concernTag(state.answers, key);
    if (tag && p) return 'Pour répondre à votre priorité « ' + tag + ' » : ' + p.description.toLowerCase() + '.';
    return p ? p.description + '.' : '';
  }

  function finishBranch() {
    state.routine = E.computeRoutine(state.answers, state.savedRoutine);
    state.selection = E.uniqueKeys(state.routine).filter(k => E.getProduct(k));
    state.phase = 'done';

    if (!state.completionTracked) {
      state.completionTracked = true;
      const now = new Date();
      E.track('Diagnostic Completed', {
        universe: [].concat(state.doneUniverses, state.answers.universe || 'skin').join('+'),
        input_method: state.inputMethod,
        lash_wishes: state.answers.lashWishes || [],
        age_range: state.answers.age || '',
        skin_type: state.answers.skinType || '',
        concerns: state.answers.concerns || [],
        morning_routine: state.routine.morning, evening_routine: state.routine.evening,
        weekly_care: state.routine.weekly, targeted_care: state.routine.targeted,
        routine_value: E.routineValueCents(state.selection) / 100,
        diagnostic_date: now.toISOString(),
        $event_id: String(Math.floor(now.getTime() / 1000)),
      });
      const idProps = E.buildIdentifyProps(state.answers, state.routine, state.doneUniverses);
      idProps.diagnostic_input_method = state.inputMethod;
      E.identify(idProps);
    }

    say(S.recoIntro);
    const shown = new Set();
    ['morning', 'evening', 'weekly', 'targeted'].forEach(section => {
      const fresh = state.routine[section].filter(k => !shown.has(k));
      if (!fresh.length) return;
      say('<b>' + S.sections[section] + '</b>');
      fresh.forEach(key => {
        shown.add(key);
        const r = reasonFor(key);
        if (r) say(r);
        push({ t: 'pcard', key, added: true });
      });
    });
    say(S.capture);
    push({ t: 'capture' });
    queue = queue.then(() => scheduleCaptureCheck());
    const next = ['skin', 'lashes'].find(u => ![].concat(state.doneUniverses, [state.answers.universe]).includes(u));
    if (next) push({ t: 'crosssell', next });
  }

  function startCrossSell(universe, fromReplay) {
    if (!fromReplay) logAction({ a: 'crosssell', universe });
    state.savedRoutine = state.routine;
    state.doneUniverses.push(state.answers.universe);
    state.answers = { universe };
    state.completionTracked = false;
    removeInputs();
    push({ t: 'user', html: S.universeReply[universe] });
    say(S.branchIntro[universe]);
    state.phase = 'questions';
    nextQuestion();
  }

  function toggleSelection(key) {
    const i = state.selection.indexOf(key);
    if (i >= 0) state.selection.splice(i, 1); else state.selection.push(key);
    renderSelection();
  }

  async function addSelectionToCart() {
    if (!state.selection.length) return;
    const btn = document.querySelector('.cb-cta');
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
    const { ok, ko } = await E.addRoutineToCart(state.selection);
    E.track('Diagnostic Routine Added to Cart', {
      products: state.selection.map(k => E.productMapping[k]).filter(Boolean),
      products_added: ok, products_failed: ko,
      value: E.routineValueCents(state.selection) / 100,
    });
    if (btn) { btn.disabled = false; btn.textContent = ok ? '✓ ' + ok + ' produit' + (ok > 1 ? 's' : '') + ' au panier' : 'Réessayer'; }
  }

  // --- Photo : upload → 1024px JPEG → Edge Function → boucle de confirmation ---
  function choosePhoto() {
    const input = el('cb-photo-input');
    if (input) input.click();
  }

  function declinePhoto(fromReplay) {
    if (!fromReplay) { logAction({ a: 'photoDecline' }); E.track('Consultation Photo Declined', {}); }
    removeInputs();
    nextQuestion();
  }

  function downscale(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        const max = 1024;
        const scale = Math.min(1, max / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve({ dataUrl: canvas.toDataURL('image/jpeg', 0.85), thumbUrl: url });
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  async function onPhotoFile(file) {
    if (!file) return;
    removeInputs();
    push({ t: 'user', html: '📸 Ma photo' });
    E.track('Consultation Photo Uploaded', {});
    say(S.photoLooking);
    let result = null;
    try {
      const { dataUrl, thumbUrl } = await downscale(file);
      state.photoThumb = thumbUrl; // mémoire navigateur uniquement, jamais persisté
      renderProfile();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      const resp = await fetch(VISION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + VISION_KEY },
        body: JSON.stringify({ image: dataUrl }),
        signal: controller.signal,
      });
      clearTimeout(timer);
      if (resp.ok) result = await resp.json();
    } catch (e) { /* silencieux : bascule questions */ }
    handleVision(result);
  }

  function handleVision(res) {
    removeInputs();
    if (!res || res.error || !res.exploitable) {
      if (res && !res.exploitable) E.track('Consultation Photo Analyzed', { exploitable: false });
      say(res && !res.exploitable ? S.photoUnusable : S.photoFail);
      nextQuestion();
      return;
    }
    E.track('Consultation Photo Analyzed', { exploitable: true, confiance: res.confiance, cadrage: res.cadrage, axes: res.axes_suggeres });
    if (res.confiance === 'faible' && !state.photoRetryUsed) {
      state.photoRetryUsed = true; // une seule relance, jamais plus
      say(S.photoCloser);
      push({ t: 'photo-retry' });
      return;
    }
    if (!res.axes_suggeres || !res.axes_suggeres.length) { say(S.photoUnusable); nextQuestion(); return; }
    state.photoAxes = res.axes_suggeres;
    if (res.message_observation) say(esc(res.message_observation));
    push({ t: 'photo-confirm', axes: res.axes_suggeres });
  }

  function confirmPhoto(accepted, fromReplay) {
    if (!state.photoAxes) return;
    if (!fromReplay) logAction({ a: 'photoAxes', axes: state.photoAxes, accepted: !!accepted });
    removeInputs();
    if (accepted) {
      state.answers.lashWishes = state.photoAxes.slice();
      state.inputMethod = 'photo';
      const labels = state.photoAxes.map(a => E.TARGET_LABELS[a] || a).join(' · ');
      push({ t: 'user', html: 'Oui, exactement — ' + esc(labels) });
      say(S.ack.lashWishes);
    } else {
      state.prefillMulti = state.photoAxes.slice(); // pré-coche, la cliente ajuste
      state.inputMethod = 'mixte';
      push({ t: 'user', html: 'Pas tout à fait, je précise' });
    }
    nextQuestion();
  }

  // Masque le bloc capture si l'embed Klaviyo ne se rend pas (profil identifié — voulu)
  function scheduleCaptureCheck() {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts++;
      const wrap = el('cb-capture');
      if (!wrap) { clearInterval(timer); return; }
      const embed = wrap.querySelector('.klaviyo-form-Re9bCe');
      if (embed && embed.children && embed.children.length > 0) { clearInterval(timer); return; }
      if (attempts >= 6) { clearInterval(timer); wrap.style.display = 'none'; }
    }, 1000);
  }

  // --- Onglets mobile ---
  function showTab(name) {
    const root = el('cb-root');
    if (!root) return;
    root.setAttribute('data-tab', name);
    ['chat', 'profile', 'selection'].forEach(t => {
      const tab = el('cb-tab-' + t);
      if (tab) tab.classList.toggle('cb-on', t === name);
    });
  }

  // --- Reprise de session ---
  function replay(actions) {
    instant = true;
    start();
    actions.forEach(act => {
      if (act.a === 'answer') answer(act.qid, act.value, true);
      else if (act.a === 'toggle') toggle(act.qid, act.value, true);
      else if (act.a === 'confirm') confirmMulti(act.qid, true);
      else if (act.a === 'crosssell') startCrossSell(act.universe, true);
      else if (act.a === 'photoDecline') declinePhoto(true);
      else if (act.a === 'photoAxes') { state.photoAxes = act.axes; confirmPhoto(act.accepted, true); }
    });
    instant = false;
  }

  function init() {
    let saved = null;
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.ts && Date.now() - parsed.ts < 2 * 60 * 60 * 1000) saved = parsed;
      }
    } catch (e) {}
    const input = el('cb-photo-input');
    if (input) input.addEventListener('change', e => { onPhotoFile(e.target.files && e.target.files[0]); e.target.value = ''; });
    if (saved && saved.actions && saved.actions.length) {
      state.actions = saved.actions.slice();
      replay(saved.actions);
    } else {
      start();
    }
    showTab('chat');
  }

  window.TalikaConsultation = {
    answer, toggle, confirmMulti, startCrossSell, toggleSelection, addSelectionToCart, showTab,
    choosePhoto, declinePhoto, confirmPhoto, _handleVision: handleVision, _onPhotoFile: onPhotoFile,
    restart() { try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      state.answers = {}; state.doneUniverses = []; state.savedRoutine = null;
      state.transcript = []; state.selection = []; state.routine = null;
      state.actions = []; state.completionTracked = false; state.pendingMulti = [];
      state.photoThumb = null; state.photoAxes = null; state.photoRetryUsed = false; state.inputMethod = 'questions';
      start(); },
    _state: state, _setInstant(v) { instant = v; },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
